import { generateMfaQrCodeAsync } from "../actions/accountActions";
import { createSlice, isAnyOf } from '@reduxjs/toolkit';

type QrcodePayload = {
    qrCodeUrl:any,
    loading: boolean,
}
const initialState: QrcodePayload = {
    qrCodeUrl: [],
    loading: false,
}

const generateMfaQrCodeAsyncSlice = createSlice({
  name: 'generateMfaQrCodeAsync',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(generateMfaQrCodeAsync.pending), (state, actions) => {
      state.loading = true
    })
    builder.addMatcher(isAnyOf(generateMfaQrCodeAsync.fulfilled), (state, action) => {
      state.qrCodeUrl= action?.payload.data
      state.loading = false
    })
    builder.addMatcher(isAnyOf(generateMfaQrCodeAsync.rejected), (state) => {
      state.loading = false
    })
  },
  reducers: {
    // getTemuCountryData: (state, action: {payload: fetchTemuCountryPayoad; type: string}) => {
    //   state.loading = action.payload?.loading
    //   state.temuCountryData = action?.payload.temuCountryData
    // },
  },
});

// export const {generateMfaQrCodeAsyncSlice} = generateMfaQrCodeAsyncSlice.actions
export default generateMfaQrCodeAsyncSlice.reducer;